import React from 'react';
import Center from '../Center';
import Spinner from '../Spinner';
import * as Styles from './PageStyles';

import { ReactComponent as Alert } from '../../../assets/icons/icon_alert.svg';

interface StatusProps {
  readonly error?: boolean;
  readonly loading?: boolean;
}

interface Props {
  children: JSX.Element;
}

type PageProps = Props & StatusProps;

const Error: React.FC = () => {
  return (
    <Styles.AlertContainer>
      <Alert />

      <Styles.AlertContent>
        <Styles.AlertTitle>Ação necessária</Styles.AlertTitle>

        <Styles.AlertDescription>
          Ocorreu um erro no sistema devido uma atualização cadastral. Faça o logoff da conta e entre novamente. Caso o
          erro permaneça, entre em contato com a equipe técnica.
        </Styles.AlertDescription>
      </Styles.AlertContent>
    </Styles.AlertContainer>
  );
};

const Page: React.FC<PageProps> = ({ children, error, loading }: PageProps) => {
  if (loading) {
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }

  if (error) {
    return (
      <Styles.Wrapper>
        <Styles.Content>
          <Error />
        </Styles.Content>
      </Styles.Wrapper>
    );
  }

  return (
    <Styles.Wrapper>
      <Styles.Content>{children}</Styles.Content>
    </Styles.Wrapper>
  );
};

export default Page;
